import React from 'react';

import { flagStyles } from '../settings';

const SvgMA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3240px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMA;
